export default __webpack_public_path__ + "static/media/911.e58cbccf.gif";